export default "__VITE_ASSET__C$SGzzUl__"